<template>
  <div id="app">
    <div class="loader" v-if="loading">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <b-card no-body>
        <b-row no-gutters>
            <MainTemperatureComponent
              :weatherData="weatherData"
              :dateBuilder="dateBuilder"
              :unit="unit"
              @citychange="handleCityChange"
            />
            <HighlightsComponent
              :weatherData="weatherData"
              :unit="unit"
              @toggleUnit="handleToggleUnit"
            />
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import MainTemperatureComponent from "./components/MainTemperatureComponent";
import HighlightsComponent from "./components/HighlightsComponent";
import axios from "axios";

export default {
  name: "app",
  components: {
    MainTemperatureComponent,
    HighlightsComponent,
  },
  data() {
    return {
      weatherData: null,
      loading: false,
      currentCoords: null,
      currentCity: {
        name: "Mumbai",
        lat: 19.076191,
        lon: 72.875877,
        country: "IN",
      },
      unit: "metric",
      apiKey: process.env.VUE_APP_WEATHER_API_KEY,
    };
  },
  methods: {
    async fetchData(cityData = this.currentCity) {
      if (!cityData) {
        cityData = this.currentCity;
      } else {
        this.currentCity = cityData;
      }
      const coordsKey = `${cityData.lat},${cityData.lon},${this.unit}`;
      if (coordsKey === this.currentCoords) return;

      this.loading = true;
      try {
        const response = await axios.get(
          `https://api.openweathermap.org/data/2.5/weather`,
          {
            params: {
              lat: cityData.lat,
              lon: cityData.lon,
              appid: this.apiKey,
              units: this.unit,
            },
          }
        );

        this.weatherData = {
          ...response.data,
          name: cityData.name,
          country: cityData.country,
        };

        this.currentCoords = coordsKey;
      } catch (err) {
        console.error("Error fetching weather:", err);
      } finally {
        this.loading = false;
      }
    },
    dateBuilder() {
      const d = new Date();
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]}`;
    },
    handleToggleUnit(selectedUnit) {
      if (this.unit !== selectedUnit) {
        this.unit = selectedUnit;
        this.fetchData();
      }
    },
    handleCityChange(newCity) {
      this.city = newCity;
      this.fetchData(newCity);
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "./assets/scss/main.scss";
@import "./assets/scss/layout.scss";
</style>